import { useState } from 'react'
import { navigate } from 'gatsby'
import {
  CustomerCreateInput,
  useCustomerCreateMutation,
} from 'lib/graphql/storeadmin'
import { SEO, showMessage } from 'components/common'
import { Editor } from 'components/customers'
import { customerErrorHandling } from 'lib/hooks'

export const Head = () => <SEO title="顧客（個人）の追加" />

const IndexPage = (): JSX.Element => {
  const [createCustomer, { loading, error }] = useCustomerCreateMutation()

  // Customer Corporate error useState
  const [showCustomerErrorAlert, setShowCustomerErrorAlert] = useState(false)
  const [customerErrorDescription, setCustomerErrorDescription] = useState([])

  const onFinishFailed = () => {
    showMessage('error', 'エラーが発生しました。')
  }

  const onFinish = async (
    allowDuplicate = true,
    values: CustomerCreateInput
  ) => {
    try {
      const { data } = await createCustomer({
        variables: { allowDuplicate, input: values },
      })
      const userErrors = data?.customerCreate?.customerUserErrors || []
      if (userErrors.length > 0) {
        setShowCustomerErrorAlert(true)
        const errorMessages = customerErrorHandling(userErrors)
        setCustomerErrorDescription(errorMessages)
        showMessage('error', 'エラーが発生しました。')
      } else if (error) {
        showMessage('error', 'エラーが発生しました。')
      } else {
        setShowCustomerErrorAlert(false)
        showMessage('success', '新規顧客を追加しました。')
        navigate(`../${data.customerCreate.customer.id}`)
      }
    } catch (e) {
      setShowCustomerErrorAlert(true)
      setCustomerErrorDescription([e.message])
      showMessage('error', 'サーバーとの通信時にエラーが発生しました。')
    }
  }
  const onCloseAlert = () => {
    setShowCustomerErrorAlert(false)
  }

  return (
    <>
      <Editor
        isNew={true}
        title="顧客（個人）を追加する"
        type="personal"
        requesting={loading}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        showAlert={showCustomerErrorAlert}
        onCloseAlert={onCloseAlert}
        alertDescription={customerErrorDescription}
      />
    </>
  )
}

export default IndexPage
